import { colors, rgba } from "@ancon/wildcat-ui/shared";
import {
  faClock,
  faTruck,
  faUtensils,
  faShop,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormContext } from "react-hook-form";
import { styled } from "styled-components";
import { FontVariant } from "../../../constants/fonts";
import { ThemeFormValuesType } from "../../../forms/app/ThemeForm";

const Card = styled.div`
  border-radius: 16px;
  margin-top: 20px;
  box-shadow: 0px 2px 8px ${rgba(colors.black, 0.05)};
  text-align: start;
`;

const OutletNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 16px;
`;

const OutletName = styled.div`
  font-weight: bold;
  font-size: 20px;
  margin-top: 10px;
`;

const OutletAddress = styled.div`
  padding: 0px 16px;
`;

const OutletMeta = styled.div`
  padding: 0px 16px 16px 16px;
`;

const OrderFormats = styled.div`
  svg {
    margin-left: 10px;
  }
`;

const OutletState = styled.div`
  padding: 10px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  svg {
    margin-right: 10px;
  }
`;

export default function OutletCard() {
  const { watch } = useFormContext<ThemeFormValuesType>();
  const values = watch();
  const { tertiary, primary, isWL } = values;
  const { surfaces: PrimarySurfaces } = primary;
  const { surfaces, content } = tertiary;
  const { default: DefaultContentColor } = content;
  const { default: DefaultSurface } = surfaces;
  const { default: DefaultPrimarySurface, alt_1: Alt1PrimarySurface } =
    PrimarySurfaces;

  return (
    <Card
      style={{
        backgroundColor: DefaultSurface.color,
      }}
    >
      <OutletState
        style={{
          color: DefaultContentColor,
          backgroundColor: isWL
            ? DefaultPrimarySurface.color
            : Alt1PrimarySurface.color,
          fontFamily: FontVariant.PrimaryRegular,
        }}
      >
        <FontAwesomeIcon icon={faClock} color={DefaultContentColor} />
        Opens Today at 11:00AM
      </OutletState>
      <OutletNameContainer>
        <OutletName
          style={{
            color: DefaultSurface.content.default,
            fontFamily: FontVariant.PrimaryBold,
          }}
        >
          Outlet Name
        </OutletName>
        <OrderFormats>
          <FontAwesomeIcon
            icon={faUtensils}
            color={colors.black}
            opacity={0.2}
          />
          <FontAwesomeIcon
            icon={faTruck}
            color={DefaultSurface.content.alt_2}
          />
          <FontAwesomeIcon icon={faShop} color={DefaultSurface.content.alt_2} />
        </OrderFormats>
      </OutletNameContainer>
      <OutletAddress
        style={{
          color: DefaultSurface.content.default,
          fontFamily: FontVariant.PrimaryRegular,
        }}
      >
        Humlegårdsgatan 1, Stockholm
      </OutletAddress>
      <OutletMeta
        style={{
          color: DefaultSurface.content.alt_1,
          fontFamily: FontVariant.PrimaryRegular,
        }}
      >
        450 m
      </OutletMeta>
    </Card>
  );
}
